// extracted by mini-css-extract-plugin
module.exports = {"svgItem":"Icon_svgItem__9QnTf","filled":"Icon_filled__1cuUw","disableHover":"Icon_disableHover__3Jv66"};